//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const SCARLETT_API_BASE_URL = new InjectionToken<string>('SCARLETT_API_BASE_URL');

export interface IScarlettMonitorsClient {
    list(isEnabled?: boolean | null | undefined, monitorKind?: string | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfHealthMonitorDto>;
    create(request: UpsertHealthMonitorRequest): Observable<HealthMonitorDto>;
    getOptions(): Observable<MonitorOptionsDto>;
    get(monitorId: number): Observable<HealthMonitorDto>;
    update(monitorId: number, request: UpsertHealthMonitorRequest): Observable<HealthMonitorDto>;
    delete(monitorId: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ScarlettMonitorsClient implements IScarlettMonitorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SCARLETT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7210";
    }

    list(isEnabled?: boolean | null | undefined, monitorKind?: string | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfHealthMonitorDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors?";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (monitorKind !== undefined && monitorKind !== null)
            url_ += "MonitorKind=" + encodeURIComponent("" + monitorKind) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHealthMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHealthMonitorDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<PagedResultDtoOfHealthMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHealthMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: UpsertHealthMonitorRequest): Observable<HealthMonitorDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthMonitorDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOptions(): Observable<MonitorOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitorOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitorOptionsDto>;
        }));
    }

    protected processGetOptions(response: HttpResponseBase): Observable<MonitorOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitorOptionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(monitorId: number): Observable<HealthMonitorDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors/{MonitorId}";
        if (monitorId === undefined || monitorId === null)
            throw new globalThis.Error("The parameter 'monitorId' must be defined.");
        url_ = url_.replace("{MonitorId}", encodeURIComponent("" + monitorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthMonitorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(monitorId: number, request: UpsertHealthMonitorRequest): Observable<HealthMonitorDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors/{MonitorId}";
        if (monitorId === undefined || monitorId === null)
            throw new globalThis.Error("The parameter 'monitorId' must be defined.");
        url_ = url_.replace("{MonitorId}", encodeURIComponent("" + monitorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthMonitorDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(monitorId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors/{MonitorId}";
        if (monitorId === undefined || monitorId === null)
            throw new globalThis.Error("The parameter 'monitorId' must be defined.");
        url_ = url_.replace("{MonitorId}", encodeURIComponent("" + monitorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScarlettNotificationsConfigClient {
    getHealth(): Observable<NotificationHealthDto>;
    getConfig(): Observable<NotificationsConfigDto>;
    listChannels(): Observable<NotificationChannelDto[]>;
    createChannel(request: UpsertNotificationChannelRequest): Observable<NotificationChannelDto>;
    updateChannel(channelId: number, request: UpsertNotificationChannelRequest): Observable<NotificationChannelDto>;
    deleteChannel(channelId: number): Observable<FileResponse>;
    listPolicies(): Observable<NotificationPolicyDto[]>;
    createPolicy(request: UpsertNotificationPolicyRequest): Observable<NotificationPolicyDto>;
    updatePolicy(policyId: number, request: UpsertNotificationPolicyRequest): Observable<NotificationPolicyDto>;
    deletePolicy(policyId: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ScarlettNotificationsConfigClient implements IScarlettNotificationsConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SCARLETT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7210";
    }

    getHealth(): Observable<NotificationHealthDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationHealthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationHealthDto>;
        }));
    }

    protected processGetHealth(response: HttpResponseBase): Observable<NotificationHealthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationHealthDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConfig(): Observable<NotificationsConfigDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationsConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationsConfigDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<NotificationsConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationsConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listChannels(): Observable<NotificationChannelDto[]> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/channels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationChannelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationChannelDto[]>;
        }));
    }

    protected processListChannels(response: HttpResponseBase): Observable<NotificationChannelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationChannelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChannel(request: UpsertNotificationChannelRequest): Observable<NotificationChannelDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/channels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationChannelDto>;
        }));
    }

    protected processCreateChannel(response: HttpResponseBase): Observable<NotificationChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateChannel(channelId: number, request: UpsertNotificationChannelRequest): Observable<NotificationChannelDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/channels/{ChannelId}";
        if (channelId === undefined || channelId === null)
            throw new globalThis.Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{ChannelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationChannelDto>;
        }));
    }

    protected processUpdateChannel(response: HttpResponseBase): Observable<NotificationChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteChannel(channelId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/channels/{ChannelId}";
        if (channelId === undefined || channelId === null)
            throw new globalThis.Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{ChannelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteChannel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listPolicies(): Observable<NotificationPolicyDto[]> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/policies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationPolicyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationPolicyDto[]>;
        }));
    }

    protected processListPolicies(response: HttpResponseBase): Observable<NotificationPolicyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationPolicyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPolicy(request: UpsertNotificationPolicyRequest): Observable<NotificationPolicyDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/policies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationPolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationPolicyDto>;
        }));
    }

    protected processCreatePolicy(response: HttpResponseBase): Observable<NotificationPolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationPolicyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePolicy(policyId: number, request: UpsertNotificationPolicyRequest): Observable<NotificationPolicyDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/policies/{PolicyId}";
        if (policyId === undefined || policyId === null)
            throw new globalThis.Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{PolicyId}", encodeURIComponent("" + policyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationPolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationPolicyDto>;
        }));
    }

    protected processUpdatePolicy(response: HttpResponseBase): Observable<NotificationPolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationPolicyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePolicy(policyId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scarlett/notifications/policies/{PolicyId}";
        if (policyId === undefined || policyId === null)
            throw new globalThis.Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{PolicyId}", encodeURIComponent("" + policyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeletePolicy(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScarlettOperationsClient {
    listIncidents(isLive?: boolean | null | undefined, monitorId?: number | null | undefined, severity?: string | null | undefined, unacknowledgedOnly?: boolean | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfIncidentDto>;
    acknowledgeIncident(incidentId: number): Observable<FileResponse>;
    listMonitorResults(monitorId: number, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfMonitorResultDto>;
    listAuditLog(category?: string | null | undefined, level?: string | null | undefined, entityType?: string | null | undefined, entityId?: string | null | undefined, actor?: string | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfAuditLogDto>;
    getAuditFilterOptions(): Observable<AuditFilterOptionsDto>;
    enqueueCommand(request: EnqueueCommandRequest): Observable<CommandDto>;
    getCommand(commandId: number): Observable<CommandDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ScarlettOperationsClient implements IScarlettOperationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SCARLETT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7210";
    }

    listIncidents(isLive?: boolean | null | undefined, monitorId?: number | null | undefined, severity?: string | null | undefined, unacknowledgedOnly?: boolean | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfIncidentDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/incidents?";
        if (isLive !== undefined && isLive !== null)
            url_ += "IsLive=" + encodeURIComponent("" + isLive) + "&";
        if (monitorId !== undefined && monitorId !== null)
            url_ += "MonitorId=" + encodeURIComponent("" + monitorId) + "&";
        if (severity !== undefined && severity !== null)
            url_ += "Severity=" + encodeURIComponent("" + severity) + "&";
        if (unacknowledgedOnly !== undefined && unacknowledgedOnly !== null)
            url_ += "UnacknowledgedOnly=" + encodeURIComponent("" + unacknowledgedOnly) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIncidentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIncidentDto>;
        }));
    }

    protected processListIncidents(response: HttpResponseBase): Observable<PagedResultDtoOfIncidentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIncidentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acknowledgeIncident(incidentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scarlett/incidents/{IncidentId}/acknowledge";
        if (incidentId === undefined || incidentId === null)
            throw new globalThis.Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{IncidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAcknowledgeIncident(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listMonitorResults(monitorId: number, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfMonitorResultDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/monitors/{MonitorId}/results?";
        if (monitorId === undefined || monitorId === null)
            throw new globalThis.Error("The parameter 'monitorId' must be defined.");
        url_ = url_.replace("{MonitorId}", encodeURIComponent("" + monitorId));
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListMonitorResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListMonitorResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMonitorResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMonitorResultDto>;
        }));
    }

    protected processListMonitorResults(response: HttpResponseBase): Observable<PagedResultDtoOfMonitorResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMonitorResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listAuditLog(category?: string | null | undefined, level?: string | null | undefined, entityType?: string | null | undefined, entityId?: string | null | undefined, actor?: string | null | undefined, skip?: number | undefined, take?: number | undefined): Observable<PagedResultDtoOfAuditLogDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/audit?";
        if (category !== undefined && category !== null)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (level !== undefined && level !== null)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (entityType !== undefined && entityType !== null)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (actor !== undefined && actor !== null)
            url_ += "Actor=" + encodeURIComponent("" + actor) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAuditLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogDto>;
        }));
    }

    protected processListAuditLog(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuditFilterOptions(): Observable<AuditFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/audit-filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditFilterOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditFilterOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditFilterOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditFilterOptionsDto>;
        }));
    }

    protected processGetAuditFilterOptions(response: HttpResponseBase): Observable<AuditFilterOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditFilterOptionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enqueueCommand(request: EnqueueCommandRequest): Observable<CommandDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/commands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDto>;
        }));
    }

    protected processEnqueueCommand(response: HttpResponseBase): Observable<CommandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommand(commandId: number): Observable<CommandDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/commands/{CommandId}";
        if (commandId === undefined || commandId === null)
            throw new globalThis.Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{CommandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandDto>;
        }));
    }

    protected processGetCommand(response: HttpResponseBase): Observable<CommandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScarlettPlatformClient {
    getCapabilities(): Observable<CallerCapabilitiesDto>;
    getOverview(): Observable<ScarlettOverviewDto>;
    getPlatformConfig(): Observable<PlatformConfigDto>;
    getStatus(): Observable<ReplicaStatusDto>;
    listSettings(): Observable<SettingDto[]>;
    updateSetting(request: UpdateSettingRequest): Observable<SettingDto>;
    listJobs(): Observable<JobDto[]>;
    updateJob(request: UpdateJobRequest): Observable<JobDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ScarlettPlatformClient implements IScarlettPlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SCARLETT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7210";
    }

    getCapabilities(): Observable<CallerCapabilitiesDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/capabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCapabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCapabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallerCapabilitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallerCapabilitiesDto>;
        }));
    }

    protected processGetCapabilities(response: HttpResponseBase): Observable<CallerCapabilitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallerCapabilitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverview(): Observable<ScarlettOverviewDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScarlettOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScarlettOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<ScarlettOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScarlettOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlatformConfig(): Observable<PlatformConfigDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/platform-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlatformConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlatformConfigDto>;
        }));
    }

    protected processGetPlatformConfig(response: HttpResponseBase): Observable<PlatformConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlatformConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatus(): Observable<ReplicaStatusDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplicaStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplicaStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<ReplicaStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplicaStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listSettings(): Observable<SettingDto[]> {
        let url_ = this.baseUrl + "/api/v1/scarlett/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingDto[]>;
        }));
    }

    protected processListSettings(response: HttpResponseBase): Observable<SettingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSetting(request: UpdateSettingRequest): Observable<SettingDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingDto>;
        }));
    }

    protected processUpdateSetting(response: HttpResponseBase): Observable<SettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listJobs(): Observable<JobDto[]> {
        let url_ = this.baseUrl + "/api/v1/scarlett/jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto[]>;
        }));
    }

    protected processListJobs(response: HttpResponseBase): Observable<JobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateJob(request: UpdateJobRequest): Observable<JobDto> {
        let url_ = this.baseUrl + "/api/v1/scarlett/jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto>;
        }));
    }

    protected processUpdateJob(response: HttpResponseBase): Observable<JobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class PagedResultDtoOfHealthMonitorDto implements IPagedResultDtoOfHealthMonitorDto {
    items!: HealthMonitorDto[];
    totalCount!: number;
    skip!: number;
    take!: number;

    constructor(data?: IPagedResultDtoOfHealthMonitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HealthMonitorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfHealthMonitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHealthMonitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IPagedResultDtoOfHealthMonitorDto {
    items: HealthMonitorDto[];
    totalCount: number;
    skip: number;
    take: number;
}

export class HealthMonitorDto implements IHealthMonitorDto {
    monitorId!: number;
    name!: string;
    description?: string | undefined;
    monitorKind!: string;
    targetRef?: string | undefined;
    configJson?: string | undefined;
    intervalSeconds!: number;
    timeoutSeconds!: number;
    severity!: string;
    failureThreshold!: number;
    recoveryThreshold!: number;
    notificationPolicyId?: number | undefined;
    isEnabled!: boolean;
    mutedUntilUtc?: DateTime | undefined;
    dependsOnMonitorId?: number | undefined;
    createdAtUtc!: DateTime;
    updatedAtUtc!: DateTime;
    updatedBy?: string | undefined;

    constructor(data?: IHealthMonitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monitorId = _data["monitorId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.monitorKind = _data["monitorKind"];
            this.targetRef = _data["targetRef"];
            this.configJson = _data["configJson"];
            this.intervalSeconds = _data["intervalSeconds"];
            this.timeoutSeconds = _data["timeoutSeconds"];
            this.severity = _data["severity"];
            this.failureThreshold = _data["failureThreshold"];
            this.recoveryThreshold = _data["recoveryThreshold"];
            this.notificationPolicyId = _data["notificationPolicyId"];
            this.isEnabled = _data["isEnabled"];
            this.mutedUntilUtc = _data["mutedUntilUtc"] ? DateTime.fromISO(_data["mutedUntilUtc"].toString()) : undefined as any;
            this.dependsOnMonitorId = _data["dependsOnMonitorId"];
            this.createdAtUtc = _data["createdAtUtc"] ? DateTime.fromISO(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? DateTime.fromISO(_data["updatedAtUtc"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthMonitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMonitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monitorId"] = this.monitorId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["monitorKind"] = this.monitorKind;
        data["targetRef"] = this.targetRef;
        data["configJson"] = this.configJson;
        data["intervalSeconds"] = this.intervalSeconds;
        data["timeoutSeconds"] = this.timeoutSeconds;
        data["severity"] = this.severity;
        data["failureThreshold"] = this.failureThreshold;
        data["recoveryThreshold"] = this.recoveryThreshold;
        data["notificationPolicyId"] = this.notificationPolicyId;
        data["isEnabled"] = this.isEnabled;
        data["mutedUntilUtc"] = this.mutedUntilUtc ? this.mutedUntilUtc.toString() : undefined as any;
        data["dependsOnMonitorId"] = this.dependsOnMonitorId;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthMonitorDto {
    monitorId: number;
    name: string;
    description?: string | undefined;
    monitorKind: string;
    targetRef?: string | undefined;
    configJson?: string | undefined;
    intervalSeconds: number;
    timeoutSeconds: number;
    severity: string;
    failureThreshold: number;
    recoveryThreshold: number;
    notificationPolicyId?: number | undefined;
    isEnabled: boolean;
    mutedUntilUtc?: DateTime | undefined;
    dependsOnMonitorId?: number | undefined;
    createdAtUtc: DateTime;
    updatedAtUtc: DateTime;
    updatedBy?: string | undefined;
}

export class MonitorOptionsDto implements IMonitorOptionsDto {
    kinds!: string[];
    severities!: string[];

    constructor(data?: IMonitorOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.kinds = [];
            this.severities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kinds"])) {
                this.kinds = [] as any;
                for (let item of _data["kinds"])
                    this.kinds!.push(item);
            }
            if (Array.isArray(_data["severities"])) {
                this.severities = [] as any;
                for (let item of _data["severities"])
                    this.severities!.push(item);
            }
        }
    }

    static fromJS(data: any): MonitorOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kinds)) {
            data["kinds"] = [];
            for (let item of this.kinds)
                data["kinds"].push(item);
        }
        if (Array.isArray(this.severities)) {
            data["severities"] = [];
            for (let item of this.severities)
                data["severities"].push(item);
        }
        return data;
    }
}

export interface IMonitorOptionsDto {
    kinds: string[];
    severities: string[];
}

export class UpsertHealthMonitorRequest implements IUpsertHealthMonitorRequest {
    name!: string;
    description?: string | undefined;
    monitorKind!: string;
    targetRef?: string | undefined;
    configJson?: string | undefined;
    intervalSeconds!: number;
    timeoutSeconds!: number;
    severity!: string;
    failureThreshold!: number;
    recoveryThreshold!: number;
    notificationPolicyId?: number | undefined;
    isEnabled!: boolean;
    mutedUntilUtc?: DateTime | undefined;
    dependsOnMonitorId?: number | undefined;

    constructor(data?: IUpsertHealthMonitorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.monitorKind = _data["monitorKind"];
            this.targetRef = _data["targetRef"];
            this.configJson = _data["configJson"];
            this.intervalSeconds = _data["intervalSeconds"];
            this.timeoutSeconds = _data["timeoutSeconds"];
            this.severity = _data["severity"];
            this.failureThreshold = _data["failureThreshold"];
            this.recoveryThreshold = _data["recoveryThreshold"];
            this.notificationPolicyId = _data["notificationPolicyId"];
            this.isEnabled = _data["isEnabled"];
            this.mutedUntilUtc = _data["mutedUntilUtc"] ? DateTime.fromISO(_data["mutedUntilUtc"].toString()) : undefined as any;
            this.dependsOnMonitorId = _data["dependsOnMonitorId"];
        }
    }

    static fromJS(data: any): UpsertHealthMonitorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertHealthMonitorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["monitorKind"] = this.monitorKind;
        data["targetRef"] = this.targetRef;
        data["configJson"] = this.configJson;
        data["intervalSeconds"] = this.intervalSeconds;
        data["timeoutSeconds"] = this.timeoutSeconds;
        data["severity"] = this.severity;
        data["failureThreshold"] = this.failureThreshold;
        data["recoveryThreshold"] = this.recoveryThreshold;
        data["notificationPolicyId"] = this.notificationPolicyId;
        data["isEnabled"] = this.isEnabled;
        data["mutedUntilUtc"] = this.mutedUntilUtc ? this.mutedUntilUtc.toString() : undefined as any;
        data["dependsOnMonitorId"] = this.dependsOnMonitorId;
        return data;
    }
}

export interface IUpsertHealthMonitorRequest {
    name: string;
    description?: string | undefined;
    monitorKind: string;
    targetRef?: string | undefined;
    configJson?: string | undefined;
    intervalSeconds: number;
    timeoutSeconds: number;
    severity: string;
    failureThreshold: number;
    recoveryThreshold: number;
    notificationPolicyId?: number | undefined;
    isEnabled: boolean;
    mutedUntilUtc?: DateTime | undefined;
    dependsOnMonitorId?: number | undefined;
}

export class NotificationHealthDto implements INotificationHealthDto {
    status!: string;
    reasons!: string[];
    windowSeconds!: number;
    pendingCount!: number;
    oldestPendingAgeSeconds!: number;
    sentInWindow!: number;
    failedInWindow!: number;
    abandonedInWindow!: number;
    undeliveredIncidentCount!: number;
    lastSentAtUtc?: DateTime | undefined;
    activeRouteCount!: number;
    throttledUntilUtc?: DateTime | undefined;
    consecutiveSendFailures!: number;
    lastSendError?: string | undefined;
    lastSendErrorAtUtc?: DateTime | undefined;
    dispatcherLastStatus?: string | undefined;
    dispatcherLastError?: string | undefined;
    dispatcherLastHeartbeatAtUtc?: DateTime | undefined;
    dispatcherConsecutiveFailures!: number;

    constructor(data?: INotificationHealthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.reasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            this.windowSeconds = _data["windowSeconds"];
            this.pendingCount = _data["pendingCount"];
            this.oldestPendingAgeSeconds = _data["oldestPendingAgeSeconds"];
            this.sentInWindow = _data["sentInWindow"];
            this.failedInWindow = _data["failedInWindow"];
            this.abandonedInWindow = _data["abandonedInWindow"];
            this.undeliveredIncidentCount = _data["undeliveredIncidentCount"];
            this.lastSentAtUtc = _data["lastSentAtUtc"] ? DateTime.fromISO(_data["lastSentAtUtc"].toString()) : undefined as any;
            this.activeRouteCount = _data["activeRouteCount"];
            this.throttledUntilUtc = _data["throttledUntilUtc"] ? DateTime.fromISO(_data["throttledUntilUtc"].toString()) : undefined as any;
            this.consecutiveSendFailures = _data["consecutiveSendFailures"];
            this.lastSendError = _data["lastSendError"];
            this.lastSendErrorAtUtc = _data["lastSendErrorAtUtc"] ? DateTime.fromISO(_data["lastSendErrorAtUtc"].toString()) : undefined as any;
            this.dispatcherLastStatus = _data["dispatcherLastStatus"];
            this.dispatcherLastError = _data["dispatcherLastError"];
            this.dispatcherLastHeartbeatAtUtc = _data["dispatcherLastHeartbeatAtUtc"] ? DateTime.fromISO(_data["dispatcherLastHeartbeatAtUtc"].toString()) : undefined as any;
            this.dispatcherConsecutiveFailures = _data["dispatcherConsecutiveFailures"];
        }
    }

    static fromJS(data: any): NotificationHealthDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHealthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["windowSeconds"] = this.windowSeconds;
        data["pendingCount"] = this.pendingCount;
        data["oldestPendingAgeSeconds"] = this.oldestPendingAgeSeconds;
        data["sentInWindow"] = this.sentInWindow;
        data["failedInWindow"] = this.failedInWindow;
        data["abandonedInWindow"] = this.abandonedInWindow;
        data["undeliveredIncidentCount"] = this.undeliveredIncidentCount;
        data["lastSentAtUtc"] = this.lastSentAtUtc ? this.lastSentAtUtc.toString() : undefined as any;
        data["activeRouteCount"] = this.activeRouteCount;
        data["throttledUntilUtc"] = this.throttledUntilUtc ? this.throttledUntilUtc.toString() : undefined as any;
        data["consecutiveSendFailures"] = this.consecutiveSendFailures;
        data["lastSendError"] = this.lastSendError;
        data["lastSendErrorAtUtc"] = this.lastSendErrorAtUtc ? this.lastSendErrorAtUtc.toString() : undefined as any;
        data["dispatcherLastStatus"] = this.dispatcherLastStatus;
        data["dispatcherLastError"] = this.dispatcherLastError;
        data["dispatcherLastHeartbeatAtUtc"] = this.dispatcherLastHeartbeatAtUtc ? this.dispatcherLastHeartbeatAtUtc.toString() : undefined as any;
        data["dispatcherConsecutiveFailures"] = this.dispatcherConsecutiveFailures;
        return data;
    }
}

export interface INotificationHealthDto {
    status: string;
    reasons: string[];
    windowSeconds: number;
    pendingCount: number;
    oldestPendingAgeSeconds: number;
    sentInWindow: number;
    failedInWindow: number;
    abandonedInWindow: number;
    undeliveredIncidentCount: number;
    lastSentAtUtc?: DateTime | undefined;
    activeRouteCount: number;
    throttledUntilUtc?: DateTime | undefined;
    consecutiveSendFailures: number;
    lastSendError?: string | undefined;
    lastSendErrorAtUtc?: DateTime | undefined;
    dispatcherLastStatus?: string | undefined;
    dispatcherLastError?: string | undefined;
    dispatcherLastHeartbeatAtUtc?: DateTime | undefined;
    dispatcherConsecutiveFailures: number;
}

export class NotificationsConfigDto implements INotificationsConfigDto {
    health!: NotificationHealthDto;
    channels!: NotificationChannelDto[];
    policies!: NotificationPolicyDto[];

    constructor(data?: INotificationsConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.health = new NotificationHealthDto();
            this.channels = [];
            this.policies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.health = _data["health"] ? NotificationHealthDto.fromJS(_data["health"]) : new NotificationHealthDto();
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(NotificationChannelDto.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(NotificationPolicyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationsConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationsConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["health"] = this.health ? this.health.toJSON() : undefined as any;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INotificationsConfigDto {
    health: NotificationHealthDto;
    channels: NotificationChannelDto[];
    policies: NotificationPolicyDto[];
}

export class NotificationChannelDto implements INotificationChannelDto {
    channelId!: number;
    name!: string;
    channelKind!: string;
    configJson!: string;
    isEnabled!: boolean;
    recipients?: string[] | undefined;
    updatedAtUtc!: DateTime;
    updatedBy?: string | undefined;

    constructor(data?: INotificationChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.name = _data["name"];
            this.channelKind = _data["channelKind"];
            this.configJson = _data["configJson"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.updatedAtUtc = _data["updatedAtUtc"] ? DateTime.fromISO(_data["updatedAtUtc"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): NotificationChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["name"] = this.name;
        data["channelKind"] = this.channelKind;
        data["configJson"] = this.configJson;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface INotificationChannelDto {
    channelId: number;
    name: string;
    channelKind: string;
    configJson: string;
    isEnabled: boolean;
    recipients?: string[] | undefined;
    updatedAtUtc: DateTime;
    updatedBy?: string | undefined;
}

export class NotificationPolicyDto implements INotificationPolicyDto {
    policyId!: number;
    name!: string;
    minSeverity!: string;
    renotifyMinutes!: number;
    notifyOnRecovery!: boolean;
    maxNotificationsPerIncident?: number | undefined;
    isEnabled!: boolean;
    channelIds!: number[];
    updatedAtUtc!: DateTime;
    updatedBy?: string | undefined;

    constructor(data?: INotificationPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.channelIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
            this.name = _data["name"];
            this.minSeverity = _data["minSeverity"];
            this.renotifyMinutes = _data["renotifyMinutes"];
            this.notifyOnRecovery = _data["notifyOnRecovery"];
            this.maxNotificationsPerIncident = _data["maxNotificationsPerIncident"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.updatedAtUtc = _data["updatedAtUtc"] ? DateTime.fromISO(_data["updatedAtUtc"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): NotificationPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        data["name"] = this.name;
        data["minSeverity"] = this.minSeverity;
        data["renotifyMinutes"] = this.renotifyMinutes;
        data["notifyOnRecovery"] = this.notifyOnRecovery;
        data["maxNotificationsPerIncident"] = this.maxNotificationsPerIncident;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface INotificationPolicyDto {
    policyId: number;
    name: string;
    minSeverity: string;
    renotifyMinutes: number;
    notifyOnRecovery: boolean;
    maxNotificationsPerIncident?: number | undefined;
    isEnabled: boolean;
    channelIds: number[];
    updatedAtUtc: DateTime;
    updatedBy?: string | undefined;
}

export class UpsertNotificationChannelRequest implements IUpsertNotificationChannelRequest {
    name!: string;
    channelKind!: string;
    recipients!: string[];
    isEnabled!: boolean;

    constructor(data?: IUpsertNotificationChannelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.channelKind = _data["channelKind"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpsertNotificationChannelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertNotificationChannelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["channelKind"] = this.channelKind;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpsertNotificationChannelRequest {
    name: string;
    channelKind: string;
    recipients: string[];
    isEnabled: boolean;
}

export class UpsertNotificationPolicyRequest implements IUpsertNotificationPolicyRequest {
    name!: string;
    minSeverity!: string;
    renotifyMinutes!: number;
    notifyOnRecovery!: boolean;
    maxNotificationsPerIncident?: number | undefined;
    isEnabled!: boolean;
    channelIds!: number[];

    constructor(data?: IUpsertNotificationPolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.channelIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.minSeverity = _data["minSeverity"];
            this.renotifyMinutes = _data["renotifyMinutes"];
            this.notifyOnRecovery = _data["notifyOnRecovery"];
            this.maxNotificationsPerIncident = _data["maxNotificationsPerIncident"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertNotificationPolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertNotificationPolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["minSeverity"] = this.minSeverity;
        data["renotifyMinutes"] = this.renotifyMinutes;
        data["notifyOnRecovery"] = this.notifyOnRecovery;
        data["maxNotificationsPerIncident"] = this.maxNotificationsPerIncident;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        return data;
    }
}

export interface IUpsertNotificationPolicyRequest {
    name: string;
    minSeverity: string;
    renotifyMinutes: number;
    notifyOnRecovery: boolean;
    maxNotificationsPerIncident?: number | undefined;
    isEnabled: boolean;
    channelIds: number[];
}

export class PagedResultDtoOfIncidentDto implements IPagedResultDtoOfIncidentDto {
    items!: IncidentDto[];
    totalCount!: number;
    skip!: number;
    take!: number;

    constructor(data?: IPagedResultDtoOfIncidentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IncidentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIncidentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIncidentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IPagedResultDtoOfIncidentDto {
    items: IncidentDto[];
    totalCount: number;
    skip: number;
    take: number;
}

export class IncidentDto implements IIncidentDto {
    incidentId!: number;
    monitorId!: number;
    monitorName!: string;
    status!: string;
    severity!: string;
    title!: string;
    summary?: string | undefined;
    firstFailureAtUtc!: DateTime;
    openedAtUtc!: DateTime;
    lastFailureAtUtc!: DateTime;
    resolvedAtUtc?: DateTime | undefined;
    failureCount!: number;
    notificationCount!: number;
    lastNotifiedAtUtc?: DateTime | undefined;
    acknowledgedBy?: string | undefined;
    acknowledgedAtUtc?: DateTime | undefined;

    constructor(data?: IIncidentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.monitorId = _data["monitorId"];
            this.monitorName = _data["monitorName"];
            this.status = _data["status"];
            this.severity = _data["severity"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.firstFailureAtUtc = _data["firstFailureAtUtc"] ? DateTime.fromISO(_data["firstFailureAtUtc"].toString()) : undefined as any;
            this.openedAtUtc = _data["openedAtUtc"] ? DateTime.fromISO(_data["openedAtUtc"].toString()) : undefined as any;
            this.lastFailureAtUtc = _data["lastFailureAtUtc"] ? DateTime.fromISO(_data["lastFailureAtUtc"].toString()) : undefined as any;
            this.resolvedAtUtc = _data["resolvedAtUtc"] ? DateTime.fromISO(_data["resolvedAtUtc"].toString()) : undefined as any;
            this.failureCount = _data["failureCount"];
            this.notificationCount = _data["notificationCount"];
            this.lastNotifiedAtUtc = _data["lastNotifiedAtUtc"] ? DateTime.fromISO(_data["lastNotifiedAtUtc"].toString()) : undefined as any;
            this.acknowledgedBy = _data["acknowledgedBy"];
            this.acknowledgedAtUtc = _data["acknowledgedAtUtc"] ? DateTime.fromISO(_data["acknowledgedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IncidentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["monitorId"] = this.monitorId;
        data["monitorName"] = this.monitorName;
        data["status"] = this.status;
        data["severity"] = this.severity;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["firstFailureAtUtc"] = this.firstFailureAtUtc ? this.firstFailureAtUtc.toString() : undefined as any;
        data["openedAtUtc"] = this.openedAtUtc ? this.openedAtUtc.toString() : undefined as any;
        data["lastFailureAtUtc"] = this.lastFailureAtUtc ? this.lastFailureAtUtc.toString() : undefined as any;
        data["resolvedAtUtc"] = this.resolvedAtUtc ? this.resolvedAtUtc.toString() : undefined as any;
        data["failureCount"] = this.failureCount;
        data["notificationCount"] = this.notificationCount;
        data["lastNotifiedAtUtc"] = this.lastNotifiedAtUtc ? this.lastNotifiedAtUtc.toString() : undefined as any;
        data["acknowledgedBy"] = this.acknowledgedBy;
        data["acknowledgedAtUtc"] = this.acknowledgedAtUtc ? this.acknowledgedAtUtc.toString() : undefined as any;
        return data;
    }
}

export interface IIncidentDto {
    incidentId: number;
    monitorId: number;
    monitorName: string;
    status: string;
    severity: string;
    title: string;
    summary?: string | undefined;
    firstFailureAtUtc: DateTime;
    openedAtUtc: DateTime;
    lastFailureAtUtc: DateTime;
    resolvedAtUtc?: DateTime | undefined;
    failureCount: number;
    notificationCount: number;
    lastNotifiedAtUtc?: DateTime | undefined;
    acknowledgedBy?: string | undefined;
    acknowledgedAtUtc?: DateTime | undefined;
}

export class PagedResultDtoOfMonitorResultDto implements IPagedResultDtoOfMonitorResultDto {
    items!: MonitorResultDto[];
    totalCount!: number;
    skip!: number;
    take!: number;

    constructor(data?: IPagedResultDtoOfMonitorResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonitorResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMonitorResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMonitorResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IPagedResultDtoOfMonitorResultDto {
    items: MonitorResultDto[];
    totalCount: number;
    skip: number;
    take: number;
}

export class MonitorResultDto implements IMonitorResultDto {
    resultId!: number;
    monitorId!: number;
    checkedAtUtc!: DateTime;
    status!: string;
    durationMs?: number | undefined;
    statusCode?: number | undefined;
    observedValue?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IMonitorResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultId = _data["resultId"];
            this.monitorId = _data["monitorId"];
            this.checkedAtUtc = _data["checkedAtUtc"] ? DateTime.fromISO(_data["checkedAtUtc"].toString()) : undefined as any;
            this.status = _data["status"];
            this.durationMs = _data["durationMs"];
            this.statusCode = _data["statusCode"];
            this.observedValue = _data["observedValue"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): MonitorResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultId"] = this.resultId;
        data["monitorId"] = this.monitorId;
        data["checkedAtUtc"] = this.checkedAtUtc ? this.checkedAtUtc.toString() : undefined as any;
        data["status"] = this.status;
        data["durationMs"] = this.durationMs;
        data["statusCode"] = this.statusCode;
        data["observedValue"] = this.observedValue;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IMonitorResultDto {
    resultId: number;
    monitorId: number;
    checkedAtUtc: DateTime;
    status: string;
    durationMs?: number | undefined;
    statusCode?: number | undefined;
    observedValue?: string | undefined;
    errorMessage?: string | undefined;
}

export class PagedResultDtoOfAuditLogDto implements IPagedResultDtoOfAuditLogDto {
    items!: AuditLogDto[];
    totalCount!: number;
    skip!: number;
    take!: number;

    constructor(data?: IPagedResultDtoOfAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogDto {
    items: AuditLogDto[];
    totalCount: number;
    skip: number;
    take: number;
}

export class AuditLogDto implements IAuditLogDto {
    auditId!: number;
    timestampUtc!: DateTime;
    level!: string;
    category!: string;
    action!: string;
    actor?: string | undefined;
    entityType?: string | undefined;
    entityId?: string | undefined;
    details?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditId = _data["auditId"];
            this.timestampUtc = _data["timestampUtc"] ? DateTime.fromISO(_data["timestampUtc"].toString()) : undefined as any;
            this.level = _data["level"];
            this.category = _data["category"];
            this.action = _data["action"];
            this.actor = _data["actor"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.details = _data["details"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditId"] = this.auditId;
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toString() : undefined as any;
        data["level"] = this.level;
        data["category"] = this.category;
        data["action"] = this.action;
        data["actor"] = this.actor;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["details"] = this.details;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAuditLogDto {
    auditId: number;
    timestampUtc: DateTime;
    level: string;
    category: string;
    action: string;
    actor?: string | undefined;
    entityType?: string | undefined;
    entityId?: string | undefined;
    details?: string | undefined;
    errorMessage?: string | undefined;
}

export class AuditFilterOptionsDto implements IAuditFilterOptionsDto {
    levels!: string[];
    categories!: string[];
    actors!: string[];

    constructor(data?: IAuditFilterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.levels = [];
            this.categories = [];
            this.actors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(item);
            }
        }
    }

    static fromJS(data: any): AuditFilterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditFilterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item);
        }
        return data;
    }
}

export interface IAuditFilterOptionsDto {
    levels: string[];
    categories: string[];
    actors: string[];
}

export class CommandDto implements ICommandDto {
    commandId!: number;
    commandKind!: string;
    targetRef?: string | undefined;
    requestedBy!: string;
    requestedAtUtc!: DateTime;
    status!: string;
    startedAtUtc?: DateTime | undefined;
    completedAtUtc?: DateTime | undefined;
    resultJson?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandId = _data["commandId"];
            this.commandKind = _data["commandKind"];
            this.targetRef = _data["targetRef"];
            this.requestedBy = _data["requestedBy"];
            this.requestedAtUtc = _data["requestedAtUtc"] ? DateTime.fromISO(_data["requestedAtUtc"].toString()) : undefined as any;
            this.status = _data["status"];
            this.startedAtUtc = _data["startedAtUtc"] ? DateTime.fromISO(_data["startedAtUtc"].toString()) : undefined as any;
            this.completedAtUtc = _data["completedAtUtc"] ? DateTime.fromISO(_data["completedAtUtc"].toString()) : undefined as any;
            this.resultJson = _data["resultJson"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["commandKind"] = this.commandKind;
        data["targetRef"] = this.targetRef;
        data["requestedBy"] = this.requestedBy;
        data["requestedAtUtc"] = this.requestedAtUtc ? this.requestedAtUtc.toString() : undefined as any;
        data["status"] = this.status;
        data["startedAtUtc"] = this.startedAtUtc ? this.startedAtUtc.toString() : undefined as any;
        data["completedAtUtc"] = this.completedAtUtc ? this.completedAtUtc.toString() : undefined as any;
        data["resultJson"] = this.resultJson;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICommandDto {
    commandId: number;
    commandKind: string;
    targetRef?: string | undefined;
    requestedBy: string;
    requestedAtUtc: DateTime;
    status: string;
    startedAtUtc?: DateTime | undefined;
    completedAtUtc?: DateTime | undefined;
    resultJson?: string | undefined;
    errorMessage?: string | undefined;
}

export class EnqueueCommandRequest implements IEnqueueCommandRequest {
    commandKind!: string;
    targetRef?: string | undefined;

    constructor(data?: IEnqueueCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandKind = _data["commandKind"];
            this.targetRef = _data["targetRef"];
        }
    }

    static fromJS(data: any): EnqueueCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandKind"] = this.commandKind;
        data["targetRef"] = this.targetRef;
        return data;
    }
}

export interface IEnqueueCommandRequest {
    commandKind: string;
    targetRef?: string | undefined;
}

export class CallerCapabilitiesDto implements ICallerCapabilitiesDto {
    actor!: string;
    capabilities!: string[];

    constructor(data?: ICallerCapabilitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.capabilities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actor = _data["actor"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
        }
    }

    static fromJS(data: any): CallerCapabilitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallerCapabilitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actor"] = this.actor;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        return data;
    }
}

export interface ICallerCapabilitiesDto {
    actor: string;
    capabilities: string[];
}

export class ScarlettOverviewDto implements IScarlettOverviewDto {
    replica!: ReplicaStatusDto;
    notifications!: NotificationHealthDto;
    counts!: OverviewCountsDto;
    jobs!: JobDto[];
    recentOpenIncidents!: IncidentDto[];

    constructor(data?: IScarlettOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.replica = new ReplicaStatusDto();
            this.notifications = new NotificationHealthDto();
            this.counts = new OverviewCountsDto();
            this.jobs = [];
            this.recentOpenIncidents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.replica = _data["replica"] ? ReplicaStatusDto.fromJS(_data["replica"]) : new ReplicaStatusDto();
            this.notifications = _data["notifications"] ? NotificationHealthDto.fromJS(_data["notifications"]) : new NotificationHealthDto();
            this.counts = _data["counts"] ? OverviewCountsDto.fromJS(_data["counts"]) : new OverviewCountsDto();
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(JobDto.fromJS(item));
            }
            if (Array.isArray(_data["recentOpenIncidents"])) {
                this.recentOpenIncidents = [] as any;
                for (let item of _data["recentOpenIncidents"])
                    this.recentOpenIncidents!.push(IncidentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScarlettOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScarlettOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["replica"] = this.replica ? this.replica.toJSON() : undefined as any;
        data["notifications"] = this.notifications ? this.notifications.toJSON() : undefined as any;
        data["counts"] = this.counts ? this.counts.toJSON() : undefined as any;
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recentOpenIncidents)) {
            data["recentOpenIncidents"] = [];
            for (let item of this.recentOpenIncidents)
                data["recentOpenIncidents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScarlettOverviewDto {
    replica: ReplicaStatusDto;
    notifications: NotificationHealthDto;
    counts: OverviewCountsDto;
    jobs: JobDto[];
    recentOpenIncidents: IncidentDto[];
}

export class ReplicaStatusDto implements IReplicaStatusDto {
    isPrimary!: boolean;
    holderId!: string;
    secondsSinceLastHeartbeat?: number | undefined;
    staleJobKeys!: string[];
    settingsLoaded!: boolean;

    constructor(data?: IReplicaStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.staleJobKeys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.holderId = _data["holderId"];
            this.secondsSinceLastHeartbeat = _data["secondsSinceLastHeartbeat"];
            if (Array.isArray(_data["staleJobKeys"])) {
                this.staleJobKeys = [] as any;
                for (let item of _data["staleJobKeys"])
                    this.staleJobKeys!.push(item);
            }
            this.settingsLoaded = _data["settingsLoaded"];
        }
    }

    static fromJS(data: any): ReplicaStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplicaStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["holderId"] = this.holderId;
        data["secondsSinceLastHeartbeat"] = this.secondsSinceLastHeartbeat;
        if (Array.isArray(this.staleJobKeys)) {
            data["staleJobKeys"] = [];
            for (let item of this.staleJobKeys)
                data["staleJobKeys"].push(item);
        }
        data["settingsLoaded"] = this.settingsLoaded;
        return data;
    }
}

export interface IReplicaStatusDto {
    isPrimary: boolean;
    holderId: string;
    secondsSinceLastHeartbeat?: number | undefined;
    staleJobKeys: string[];
    settingsLoaded: boolean;
}

export class OverviewCountsDto implements IOverviewCountsDto {
    monitors!: number;
    enabledMonitors!: number;
    mutedMonitors!: number;
    openIncidents!: number;
    unacknowledgedIncidents!: number;
    openCritical!: number;
    openWarning!: number;
    openInfo!: number;

    constructor(data?: IOverviewCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monitors = _data["monitors"];
            this.enabledMonitors = _data["enabledMonitors"];
            this.mutedMonitors = _data["mutedMonitors"];
            this.openIncidents = _data["openIncidents"];
            this.unacknowledgedIncidents = _data["unacknowledgedIncidents"];
            this.openCritical = _data["openCritical"];
            this.openWarning = _data["openWarning"];
            this.openInfo = _data["openInfo"];
        }
    }

    static fromJS(data: any): OverviewCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monitors"] = this.monitors;
        data["enabledMonitors"] = this.enabledMonitors;
        data["mutedMonitors"] = this.mutedMonitors;
        data["openIncidents"] = this.openIncidents;
        data["unacknowledgedIncidents"] = this.unacknowledgedIncidents;
        data["openCritical"] = this.openCritical;
        data["openWarning"] = this.openWarning;
        data["openInfo"] = this.openInfo;
        return data;
    }
}

export interface IOverviewCountsDto {
    monitors: number;
    enabledMonitors: number;
    mutedMonitors: number;
    openIncidents: number;
    unacknowledgedIncidents: number;
    openCritical: number;
    openWarning: number;
    openInfo: number;
}

export class JobDto implements IJobDto {
    jobKey!: string;
    displayName!: string;
    isEnabled!: boolean;
    intervalSeconds!: number;
    actualIntervalSeconds?: number | undefined;
    isIntervalEditable!: boolean;
    canToggleEnabled!: boolean;
    disabledFallbackIntervalSeconds?: number | undefined;
    cadenceNote?: string | undefined;
    lastHeartbeatAtUtc?: DateTime | undefined;
    lastCompletedAtUtc?: DateTime | undefined;
    lastStatus?: string | undefined;
    lastError?: string | undefined;
    consecutiveFailureCount!: number;
    updatedAtUtc!: DateTime;
    updatedBy?: string | undefined;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobKey = _data["jobKey"];
            this.displayName = _data["displayName"];
            this.isEnabled = _data["isEnabled"];
            this.intervalSeconds = _data["intervalSeconds"];
            this.actualIntervalSeconds = _data["actualIntervalSeconds"];
            this.isIntervalEditable = _data["isIntervalEditable"];
            this.canToggleEnabled = _data["canToggleEnabled"];
            this.disabledFallbackIntervalSeconds = _data["disabledFallbackIntervalSeconds"];
            this.cadenceNote = _data["cadenceNote"];
            this.lastHeartbeatAtUtc = _data["lastHeartbeatAtUtc"] ? DateTime.fromISO(_data["lastHeartbeatAtUtc"].toString()) : undefined as any;
            this.lastCompletedAtUtc = _data["lastCompletedAtUtc"] ? DateTime.fromISO(_data["lastCompletedAtUtc"].toString()) : undefined as any;
            this.lastStatus = _data["lastStatus"];
            this.lastError = _data["lastError"];
            this.consecutiveFailureCount = _data["consecutiveFailureCount"];
            this.updatedAtUtc = _data["updatedAtUtc"] ? DateTime.fromISO(_data["updatedAtUtc"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobKey"] = this.jobKey;
        data["displayName"] = this.displayName;
        data["isEnabled"] = this.isEnabled;
        data["intervalSeconds"] = this.intervalSeconds;
        data["actualIntervalSeconds"] = this.actualIntervalSeconds;
        data["isIntervalEditable"] = this.isIntervalEditable;
        data["canToggleEnabled"] = this.canToggleEnabled;
        data["disabledFallbackIntervalSeconds"] = this.disabledFallbackIntervalSeconds;
        data["cadenceNote"] = this.cadenceNote;
        data["lastHeartbeatAtUtc"] = this.lastHeartbeatAtUtc ? this.lastHeartbeatAtUtc.toString() : undefined as any;
        data["lastCompletedAtUtc"] = this.lastCompletedAtUtc ? this.lastCompletedAtUtc.toString() : undefined as any;
        data["lastStatus"] = this.lastStatus;
        data["lastError"] = this.lastError;
        data["consecutiveFailureCount"] = this.consecutiveFailureCount;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IJobDto {
    jobKey: string;
    displayName: string;
    isEnabled: boolean;
    intervalSeconds: number;
    actualIntervalSeconds?: number | undefined;
    isIntervalEditable: boolean;
    canToggleEnabled: boolean;
    disabledFallbackIntervalSeconds?: number | undefined;
    cadenceNote?: string | undefined;
    lastHeartbeatAtUtc?: DateTime | undefined;
    lastCompletedAtUtc?: DateTime | undefined;
    lastStatus?: string | undefined;
    lastError?: string | undefined;
    consecutiveFailureCount: number;
    updatedAtUtc: DateTime;
    updatedBy?: string | undefined;
}

export class PlatformConfigDto implements IPlatformConfigDto {
    settings!: SettingDto[];
    jobs!: JobDto[];

    constructor(data?: IPlatformConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.settings = [];
            this.jobs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(SettingDto.fromJS(item));
            }
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(JobDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlatformConfigDto {
    settings: SettingDto[];
    jobs: JobDto[];
}

export class SettingDto implements ISettingDto {
    settingKey!: string;
    settingValue!: string;
    description?: string | undefined;
    isKnown!: boolean;
    defaultValue?: string | undefined;
    min?: number | undefined;
    max?: number | undefined;
    requiredCapability!: string;
    updatedAtUtc!: DateTime;
    updatedBy?: string | undefined;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["settingKey"];
            this.settingValue = _data["settingValue"];
            this.description = _data["description"];
            this.isKnown = _data["isKnown"];
            this.defaultValue = _data["defaultValue"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.requiredCapability = _data["requiredCapability"];
            this.updatedAtUtc = _data["updatedAtUtc"] ? DateTime.fromISO(_data["updatedAtUtc"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingKey"] = this.settingKey;
        data["settingValue"] = this.settingValue;
        data["description"] = this.description;
        data["isKnown"] = this.isKnown;
        data["defaultValue"] = this.defaultValue;
        data["min"] = this.min;
        data["max"] = this.max;
        data["requiredCapability"] = this.requiredCapability;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISettingDto {
    settingKey: string;
    settingValue: string;
    description?: string | undefined;
    isKnown: boolean;
    defaultValue?: string | undefined;
    min?: number | undefined;
    max?: number | undefined;
    requiredCapability: string;
    updatedAtUtc: DateTime;
    updatedBy?: string | undefined;
}

export class UpdateSettingRequest implements IUpdateSettingRequest {
    settingKey!: string;
    settingValue!: string;

    constructor(data?: IUpdateSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["settingKey"];
            this.settingValue = _data["settingValue"];
        }
    }

    static fromJS(data: any): UpdateSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingKey"] = this.settingKey;
        data["settingValue"] = this.settingValue;
        return data;
    }
}

export interface IUpdateSettingRequest {
    settingKey: string;
    settingValue: string;
}

export class UpdateJobRequest implements IUpdateJobRequest {
    jobKey!: string;
    isEnabled!: boolean;
    intervalSeconds!: number;

    constructor(data?: IUpdateJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobKey = _data["jobKey"];
            this.isEnabled = _data["isEnabled"];
            this.intervalSeconds = _data["intervalSeconds"];
        }
    }

    static fromJS(data: any): UpdateJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobKey"] = this.jobKey;
        data["isEnabled"] = this.isEnabled;
        data["intervalSeconds"] = this.intervalSeconds;
        return data;
    }
}

export interface IUpdateJobRequest {
    jobKey: string;
    isEnabled: boolean;
    intervalSeconds: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ScarlettApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isScarlettApiException = true;

    static isScarlettApiException(obj: any): obj is ScarlettApiException {
        return obj.isScarlettApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ScarlettApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}